import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { color, r } from '../../theme/tokens';
import { ROW_ANALYSIS_STATES } from './mergeAnalysis';
import {
  ROW_STATE_ANALYZING,
  ROW_STATE_NOT_ANALYZED,
  ROW_STATE_NO_STUDIES,
  ROW_STATE_NOT_IN_LIBRARY,
} from './copy';

const TEXT = {
  [ROW_ANALYSIS_STATES.ANALYZING]: ROW_STATE_ANALYZING,
  [ROW_ANALYSIS_STATES.NOT_ANALYZED]: ROW_STATE_NOT_ANALYZED,
  [ROW_ANALYSIS_STATES.NO_STUDIES]: ROW_STATE_NO_STUDIES,
  [ROW_ANALYSIS_STATES.NOT_IN_LIBRARY]: ROW_STATE_NOT_IN_LIBRARY,
};

/**
 * RowAnalysisState — one muted line under a supplement's name saying what the
 * analysis knows about it, where the score ring cannot (see
 * `rowAnalysisState` in `mergeAnalysis.js` for which state applies when).
 *
 * Muted like the notes under the list: nothing here is an error. "Not
 * analyzed yet" takes the accent colour, because it is the one state the
 * member can act on — Analyze again.
 */
const RowAnalysisState = ({ state }) => {
  const text = TEXT[state];
  if (!text) return null;
  const actionable = state === ROW_ANALYSIS_STATES.NOT_ANALYZED;
  return (
    <Box
      data-testid="row-analysis-state"
      data-state={state}
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: r(6),
        marginTop: r(4),
        fontSize: r(12),
        lineHeight: 1.45,
        color: actionable ? color.accent : color.inkMuted,
        fontWeight: actionable ? 600 : 400,
      }}
    >
      {state === ROW_ANALYSIS_STATES.ANALYZING && (
        <CircularProgress size={r(10)} thickness={6} sx={{ color: color.inkMuted }} aria-hidden="true" />
      )}
      <span>{text}</span>
    </Box>
  );
};

export default RowAnalysisState;
